import styled from 'styled-components';
import { mediaQueries } from 'developer-docs-shared-components/utils/mediaQueries';
import useMDXLayout from 'developer-docs-shared-components/hooks/useMDXLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const Div = styled.div.withConfig({
  displayName: "GutterContainer__Div",
  componentId: "sc-14loawu-0"
})(["", "{max-width:none;width:", ";margin-left:", ";}", "{width:", ";margin-left:", ";}"], mediaQueries.aboveLaptop, ({
  size
}) => size === 'medium' ? '106%' : '108%', ({
  size
}) => size === 'medium' ? '-3%' : '-4%', mediaQueries.aboveWidth(1540), ({
  size
}) => size === 'medium' ? '110%' : '123%', ({
  size
}) => size === 'medium' ? '-5%' : '-11.5%');

/**
 * @internal
 * Allows a component to expand into the gutter of a public-facing page's
 * wrapper. Used internally by several MDX components with `size` in their
 * component API.
 */
const GutterContainer = ({
  children,
  size
}) => {
  const isMDXLayout = useMDXLayout();
  if (!isMDXLayout || isMDXLayout && size === 'container') {
    // Do not wrap
    return children;
  }
  return /*#__PURE__*/_jsx(Div, {
    size: size,
    children: children
  });
};
export default GutterContainer;